<template>
  <div>
    <div>
      <Toast :title="errorMessage" :error="true" :showToast="isError" />
    </div>
    <div class="main">
      <div class="col-8 m-auto bg-white">
        <div class="p-4">
          <h1 class="mb-3 login__title">{{ title }}</h1>
          <p class="login__content">{{ content }}</p>
          <form @submit.prevent="onSubmit">
            <b-row class="inputs-wrapper">
              <b-col cols="12" class="phone-num">
                <Input
                  v-if="showNumberInput"
                  v-model="firstInputValue"
                  :loginWithValue="phoneNumberInput"
                  :type="firstInputType"
                  :title="firstTitle"
                  maxLength="11"
                  :required="true"
                />
              </b-col>
              <b-col cols="12" v-if="this.$route.name === 'checkVerifyToken'" class="d-flex align-items-center justify-content-between">
                <span v-if="sec === 0" class="send-again" @click="sendAgain">
                  {{ $t('login.sendAgain') }}
                </span>
                <span v-else></span>
                <span class="timer">00:{{ sec }}</span>
              </b-col>
              <b-col cols="12" class="password mt-4">
                <Input v-if="showPasswordInput" :required="true" v-model="secondInputValue" :loginWithValue="passwordInput" :type="secondInputType" :title="secondTitle" />
              </b-col>
              <b-col v-if="showOtp" cols="12" id="forget-pass">
                <router-link to="sendVerifyToken">
                  <span :style="{ color: color }">بازیابی رمز عبور</span>
                </router-link>
              </b-col>
              <b-row class="mt-3 main-captcha-conatainer">
                <b-col v-if="showCaptcha" cols="6">
                  <Input v-if="showNumberInput" v-model="captchaCode" :type="firstInputType" title="کد امنیتی" />
                </b-col>

                <b-col v-if="showCaptcha" cols="6" class="pl__0">
                  <div class="d-flex align-items-start justify-content-between h-100">
                    <div class="w-100 captcha__container">
                      <img class="captchaImage" :src="captchaImageUrl" alt="" />
                    </div>

                    <div @click="resendCaptcha()" class="d-flex align-items-center justify-content-center refresh__icon_container">
                      <img src="@/assets/images/refresh-logo.svg" alt="" />
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-row>
            <div class="button">
              <Button :bgColor="color" :title="buttonText" type="submit" />
            </div>
            <b-col v-if="this.$route.name !== 'login'" cols="12" class="justify-content-end p-0 mt-2">
              <div class="_back" @click="gotoPervPage">
                <span>{{ $t('login.goBack') }}</span>
                <img src="@/assets/images/back.svg" />
              </div>
            </b-col>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IdpDataProvider from '../../services/idp'
import { setToken, setRefreshToken } from '../../services/jwt'
import API from '../../services/api'
import Input from '../common/Input'
import Button from '../login/LoginButton.vue'
import Toast from '../common/Toast.vue'
import SideNavDataProvider from '../../services/sideNav'
export default {
  components: {
    Input,
    Button,
    Toast,
  },
  props: {
    firstTitle: {
      type: String,
    },
    secondTitle: {
      type: String,
    },
    showNumberInput: {
      type: Boolean,
      default: true,
    },
    showPasswordInput: {
      type: Boolean,
      default: true,
    },
    showOtp: {
      type: Boolean,
      default: false,
    },
    firstInputType: {
      type: String,
    },
    secondInputType: {
      type: String,
    },
    buttonText: {
      type: String,
    },
  },
  data() {
    return {
      firstInputValue: null,
      secondInputValue: null,
      phone_Number: null,
      isError: false,
      errorMessage: null,
      sec: 59,
      title: null,
      content: null,
      color: null,
      showCaptcha: false,
      captchaImageUrl: null,
      captchaToken: null,
      captchaText: null,
      captchaCode: null,
      phoneNumberInput: false,
      passwordInput: false,
      rolePermissions: [],
    }
  },
  created() {
    this.$store.commit('sideNav/ADD_SIDE_LINKS', null)
    this.countDownTimer()
    IdpDataProvider.getPagePermisions({
      path: '/login',
    }).then((res) => {
      this.title = res.data.data.config.title
      this.content = res.data.data.config.content
      this.color = res.data.data.config.color
    })
  },
  methods: {
    resendCaptcha() {
      IdpDataProvider.generateCaptcha().then((res) => {
        this.captchaImageUrl = res.data.captchaImgUrl
        this.captchaToken = res.data.captchaToken
        this.captchaText = res.data.captchaText
      })
    },
    onSubmit() {
      switch (this.$route.name) {
        case 'login':
          this.login()
          break
        case 'resetpassword':
          this.changePassword()
          break
        case 'sendVerifyToken':
          this.sendOpt()
          break
        case 'checkVerifyToken':
          this.passwordLess()
          break
      }
    },

    async checkRolePermission() {
      try {
        const req = await SideNavDataProvider.sideLinks()
        this.rolePermissions = req.data.data.sidebarMenuDto
        if (!this.rolePermissions[0]) {
          this.isError = false
          this.$nextTick(() => {
            this.isError = true
            this.errorMessage = 'کاربر گرامی شما برای استفاده از امکانات سایت مجوز لازم را ندارید.'
          })
        } else {
          this.$router.push({ path: this.rolePermissions[0].link })
        }
      } catch (error) {
        console.log(error)
      }
    },

    login() {
      this.isError = false
      if (this.firstInputValue && this.secondInputValue) {
        IdpDataProvider.Login({
          phoneNumber: this.firstInputValue,
          password: this.secondInputValue,
          captchaText: this.captchaText,
          captchaToken: this.captchaToken,
          captchaCode: this.captchaCode,
        })
          .then((res) => {
            window.localStorage.setItem('phoneNumber', this.firstInputValue)
            setToken(res.data.access_token)
            setRefreshToken(res.data.refresh_token)
            API.addAuthorizationHeader()
            this.checkRolePermission()
          })
          .catch((error) => {
            this.isError = true
            this.secondInputValue = null

            if (error.response.status === 499) {
              this.showCaptcha = true
              IdpDataProvider.generateCaptcha().then((res) => {
                this.captchaImageUrl = res.data.captchaImgUrl
                this.captchaToken = res.data.captchaToken
                this.captchaText = res.data.captchaText
              })
            }
            this.errorMessage = error.response.data.message
          })
      } else {
        // ui ro update kon begu por nakardi
      }
    },
    changePassword() {
      this.isError = false
      IdpDataProvider.changePassword({
        password: this.firstInputValue,
        confirmPassword: this.secondInputValue,
      })
        .then((res) => {
          if (res.status === 200) {
            setToken(res.data.access_token)
            setRefreshToken(res.data.refresh_token)
            API.addAuthorizationHeader()
            this.$router.push({ path: '/' })
          }
        })
        .catch((error) => {
          this.isError = true
          this.errorMessage = error.response.data.message
        })
    },
    sendOpt() {
      this.isError = false
      if (this.$route.name === 'sendVerifyToken') {
        window.localStorage.setItem('phoneNumber', this.firstInputValue)
        this.phone_Number = window.localStorage.getItem('phoneNumber')
      } else {
        this.phone_Number = window.localStorage.getItem('phoneNumber')
      }
      IdpDataProvider.sendVerifyToken({ phoneNumber: this.phone_Number })
        .then((res) => {
          if (this.$route.name === 'checkVerifyToken') return
          this.$router.push({ path: 'checkVerifyToken' })
        })
        .catch((error) => {
          this.isError = true
          this.errorMessage = error.response.data.message
        })
    },
    passwordLess() {
      this.isError = false
      const _phoneNumber = window.localStorage.getItem('phoneNumber')
      IdpDataProvider.passwordLess({
        verifyCode: this.firstInputValue,
        phone: _phoneNumber,
        captchaCode: this.captchaCode && this.captchaCode.length ? this.captchaCode : undefined,
        captchaText: this.captchaText && this.captchaText.length ? this.captchaText : undefined,
        captchaToken: this.captchaToken && this.captchaToken.length ? this.captchaToken : undefined,
      })
        .then((res) => {
          setToken(res.data.access_token)
          setRefreshToken(res.data.refresh_token)
          API.addAuthorizationHeader()
          this.$router.push({ path: 'resetPassword' })
        })
        .catch((error) => {
          this.isError = true
          if (error.response.status === 499) {
            this.showCaptcha = true
            IdpDataProvider.generateCaptcha().then((res) => {
              this.captchaImageUrl = res.data.captchaImgUrl
              this.captchaToken = res.data.captchaToken
              this.captchaText = res.data.captchaText
            })
          }
          this.errorMessage = error.response.data.message
        })
    },
    gotoPervPage() {
      this.$router.go(-1)
    },
    sendAgain() {
      this.sec = 59
      this.countDownTimer()
      this.sendOpt()
    },
    countDownTimer() {
      if (this.sec > 0) {
        setTimeout(() => {
          this.sec -= 1
          this.countDownTimer()
        }, 1000)
      }
    },
  },
  watch: {
    firstInputValue(val) {
      if (val !== '') {
        this.phoneNumberInput = true
      }
    },
    secondInputValue(val) {
      if (val !== '') {
        this.passwordInput = true
      }
    },
  },
  mounted() {},
}
</script>

<style scoped lang="scss">
@import '../../design/custom/components/_login.scss';
.alert-popUp {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  background: white;
  border: none;
  align-items: center;
  min-width: 450px;
  border-radius: 9px;
  height: 90px;
  text-align: right;
  position: fixed;
  z-index: 9999;
  bottom: 50px;
  right: 275px;
}
::v-deep .alert {
  padding: 0;
}

.captcha__container {
  box-shadow: 0px 0px 5px 3px rgb(189 189 189 / 25%);
  height: 80%;
  border-radius: 8px;
  overflow: hidden;
}
.captchaImage {
  height: 47px;
  width: 100%;
}
img {
  display: none;
}
img[src] {
  display: block;
}
.refresh__icon_container {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  height: 80%;
  width: 48px;
  margin-right: 15px;
  cursor: pointer;
}
.main-captcha-conatainer {
  padding-left: 0 !important;
  .pl__0 {
    padding-left: 0 !important;
  }
}
.login__title {
  font-weight: 600;
}
.login__content {
  font-weight: 400;
}
</style>
